import React from "react";
import { Hero } from "./Hero";
import { ProblemSection } from "./ProblemSection";
import { BeforeAfter } from "./BeforeAfter";
import { PainPoints } from "./PainPoints";
import { VolumesSection } from "./VolumesSection";
import { ToolsSection } from "./ToolsSection";
import { BonusesSection } from "./BonusesSection";
import { OfferSection } from "./OfferSection";
import { Guarantee } from "./Guarantee";
import { Testimonials } from "./Testimonials";
import { AboutAuthor } from "./AboutAuthor";
import { FaqSection } from "./FaqSection";
import { FinalCta } from "./FinalCta";
import { Footer } from "./Footer";
import { FloatingCta } from "./FloatingCta";
import { SalesPopup } from "./SalesPopup";
export function SalesPage() {
  return <div className="w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-244" data-mp="2o6i9calzd1b1">
      <Hero data-id="element-245" data-mp="3bx44506z4p33" />
      <main data-id="element-246" data-mp="3bwcfk9bsnrmb">
        <ProblemSection data-id="element-247" data-mp="3bvt0r1hfxjci" />
        <BeforeAfter data-id="element-248" data-mp="3godqnrx87car" />
        <PainPoints data-id="element-249" data-mp="3govub9m7wssp" />
        <VolumesSection data-id="element-250" data-mp="3gpfbgo41nd5o" />
        <ToolsSection data-id="element-251" data-mp="3gqqj4z0m1522" />
        <BonusesSection data-id="element-252" data-mp="3swqdgwhwdoai" />
        <OfferSection data-id="element-253" data-mp="3sw8azi4n6du5" />
        <Guarantee data-id="element-254" data-mp="3sxjav6uyv1fz" />
        <Testimonials data-id="element-255" data-mp="3sux6fg3dh21z" />
        <AboutAuthor data-id="element-256" data-mp="3nxwvorvkvb4j" />
        <FaqSection data-id="element-257" data-mp="3nyoj3ff0u2jq" />
        <FinalCta data-id="element-258" data-mp="3nz7zgrp0wivn" />
      </main>
      <Footer data-id="element-259" data-mp="3nvu1rwrb0xuj" />
      <FloatingCta data-id="element-260" data-mp="6hf3hozbsbdr" />
      <SalesPopup data-id="element-261" data-mp="6hx4t00uhfsj" />
    </div>;
}